import React from 'react';
import {Button, ButtonGroup} from 'reactstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';

export const sizePerPageRenderer = ({
                                        options,
                                        currSizePerPage,
                                        onSizePerPageChange,
                                    }) => (
    <ButtonGroup>
        {
            options.map((option) => {
                const isSelect = currSizePerPage === `${option.page}`;
                return (
                    <Button
                        key={option.text}
                        onClick={() => onSizePerPageChange(option.page)}
                        size='sm'
                        color={isSelect ? 'secondary' : 'warning'}
                    >
                        {option.text}
                    </Button>
                );
            })
        }
    </ButtonGroup>
);

export const pagination = (options) => {
    return paginationFactory({
        ...options, sizePerPageRenderer,
        sizePerPageList: [{
            text: '25', value: 25,
        }, {
            text: '50', value: 50,
        }, {
            text: '100', value: 100,
        }],
        hidePageListOnlyOnePage: true,
        hideSizePerPage: options.totalSize <= 25,
    });
};

export const standardTableProps = {
    striped: true,
    hover: true,
    bordered: false,
    bootstrap4: true,
    remote: true,
};



// WEBPACK FOOTER //
// ./src/common/BootstrapTools.js